import React, {Component} from 'react'

class Event extends Component {
	constructor(props) {
		super(props)
		this.state = props.data
	}

	render() {
		return (
			<div className="event-cell">
				<h3>{this.state.name}</h3>
				<p>
					Upvotes: {this.state.upvotes} <br/><br/>
					Description: {this.state.description}
				</p>
			</div>
		)
	}
}

export default Event